/**
 * Determines if design lab tabs should be reordered based on the ab_design_lab_reorder_tabs experiment
 * Variant 1 (candidate) shows the new order: Upload -> Design -> Products -> Sizes
 * Variant 0 (control) shows the original order: Upload -> Products -> Sizes -> Front -> Back
 * @param experimentValue - The experiment variant value (0-1)
 * @returns true if tabs should be reordered, false if original order should be used
 */
export function shouldReorderDesignLabTabs(experimentValue: number | undefined): boolean {
  return experimentValue === 1;
}

/**
 * Determines if exit intent modal should be shown based on ab_exit_modal_design_lab experiment
 * Variant 1 (candidate) shows the modal on exit intent and inactivity
 * Variant 0 (control) disables the modal entirely
 * @param experimentValue - The experiment variant value (0-1)
 * @returns true if modal should be enabled, false if disabled
 */
export function shouldShowExitIntentModal(experimentValue: number | undefined): boolean {
  return experimentValue === 1;
}
